export interface ShippingTermConstructor {
  id: number
  name: string
  description: string
  active: boolean
}

export class ShippingTerm {
  readonly id: number
  readonly name: string
  readonly description: string
  readonly active: boolean

  constructor(data: ShippingTermConstructor) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.active = data.active
  }
}
